import TagDetailsSection from './TagDetailsSection'

export default TagDetailsSection
